import React, { useRef, useState } from 'react';
import { useForkRef } from '../../hooks/useForkRef';
import { omitKeys } from '../../utils/object';
import { STICKY_OPTIONS_KEYS, getStickyContainerStyle, getStickyChildStyle, DEFAULT_STICKY_STATE, } from './stickyEmulation';
import { useBaseSticky } from './useBaseSticky';
export function BaseSticky(props) {
    const { containerClassName, containerStyle, containerRef, forwardRef, style, ...restProps } = omitKeys(props, STICKY_OPTIONS_KEYS);
    const containerStickyRef = useRef(null);
    const containerForkRef = useForkRef(containerRef, containerStickyRef);
    const childStickyRef = useRef(null);
    const childForkRef = useForkRef(forwardRef, childStickyRef);
    const [stickyState, setStickyState] = useState(DEFAULT_STICKY_STATE);
    useBaseSticky(stickyState, setStickyState, props, containerStickyRef, childStickyRef);
    return (React.createElement("div", { className: containerClassName, style: {
            ...getStickyContainerStyle(stickyState, props),
            ...containerStyle || {},
        }, ref: containerForkRef },
        React.createElement("div", Object.assign({}, restProps, { style: {
                ...getStickyChildStyle(stickyState, props),
                ...style || {},
            }, ref: childForkRef }))));
}
//# sourceMappingURL=BaseSticky.js.map